import { breakpointsTailwind, useBreakpoints as useBreakpointsVueUse } from "@vueuse/core";

// see https://vueuse.org/core/useBreakpoints/ for usage examples
export const useBreakpoints = () => useBreakpointsVueUse(breakpointsTailwind, { ssrWidth: 1200 });
